module.exports = __webpack_public_path__ + "img/bg.9b589233.png";